import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.25628 2.99971C7.03147 1.66676 8.96849 1.66676 9.74368 2.99971L14.3937 10.9997C15.169 12.3329 14.2003 13.9998 12.65 13.9998H3.34996C1.79968 13.9998 0.831006 12.333 1.60618 10.9998L6.25628 2.99971ZM7.41867 3.66663L2.76873 11.6665C2.51041 12.1107 2.83302 12.6665 3.34996 12.6665H12.65C13.1669 12.6665 13.4896 12.1108 13.2313 11.6666L8.58129 3.66663C8.32285 3.22224 7.67711 3.22224 7.41867 3.66663ZM7.99998 5.99983C8.37067 5.99983 8.67117 6.29831 8.67117 6.6665V7.99983C8.67117 8.36802 8.37067 8.6665 7.99998 8.6665C7.62929 8.6665 7.32879 8.36802 7.32879 7.99983V6.6665C7.32879 6.29831 7.62929 5.99983 7.99998 5.99983ZM7.32879 10.6665C7.32879 10.2983 7.62929 9.99983 7.99998 9.99983H8.00669C8.37738 9.99983 8.67788 10.2983 8.67788 10.6665C8.67788 11.0347 8.37738 11.3332 8.00669 11.3332H7.99998C7.62929 11.3332 7.32879 11.0347 7.32879 10.6665Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}